module.exports = __webpack_public_path__ + "static/img/c5.413cfc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/c5.png
// module id = yaXl
// module chunks = 0